import React, { useEffect } from 'react';
import { Tab } from '@mui/material';
import TabContext from '@mui/lab/TabContext';
import TabPanel from '@mui/lab/TabPanel';
import { PageContainer, TabListFp } from 'components';
import { useStyles } from './style';
import useCustomHook from './hooks';
import { CardsList, ShebasList, ContactList } from './components';
import { getDynamicObjectAction, constBreadCrumbsTitle } from 'utility';
import { useLocation } from 'react-router-dom';
const Cards = () => {
  // -- STATES --//
  const { activeTab, setActiveTab } = useCustomHook();
  const currentLoaction = useLocation();
  // -- HOOKS --//
  const classes = useStyles();
  let actionsList = getDynamicObjectAction([
    'shebaCardPage',
    'cardsCardPage',
    'contactsCardPage',
    'shebaImprestCardPage',
    'cardsImprestCardPage',
    'contactsImprestCardPage'
  ]);


  let panels = [
    { label: "کارت‌های بانکی", value: <CardsList />, action: String(currentLoaction?.pathname).toUpperCase().includes('IMPREST') ? 'cardsImprestCardPage' : 'cardsCardPage' },
    { label: "شماره‌های شبا", value: <ShebasList />, action: String(currentLoaction?.pathname).toUpperCase().includes('IMPREST') ? 'shebaImprestCardPage' : 'shebaCardPage' },
    { label: "لیست مخاطبین", value: <ContactList />, action: String(currentLoaction?.pathname).toUpperCase().includes('IMPREST') ? 'contactsImprestCardPage' : 'contactsCardPage' },
  ];

  const newPanels = panels.filter(panel => actionsList[panel.action]);
  panels = newPanels

  const hint =
    'در این صفحه می توانید لیست کارت ها، شماره های شبا و مخاطبینی که به عنوان مقصد تراکنش از آن ها استفاده می کنید را مشاهده نمایید.';

const getKeyBreadCrumbsWithUrl = () => {
  const path = currentLoaction?.pathname;
  if (!path) return null;

  return path.toUpperCase().includes('IMPREST')
    ? constBreadCrumbsTitle.IMPREST_CARDS
    : constBreadCrumbsTitle.BFO_CARDS;
};
  
  return (
    <PageContainer title="دفترچه" description={hint} breadcrumbs={getKeyBreadCrumbsWithUrl()}>
      {(String(currentLoaction?.pathname).toUpperCase().includes('IMPREST') ? actionsList['contactsImprestCardPage'] || actionsList['shebaImprestCardPage'] || actionsList['cardsImprestCardPage'] : actionsList['shebaCardPage'] || actionsList['cardsCardPage'] || actionsList['contactsCardPage']) && (
        <TabContext value={activeTab}>
          <TabListFp onChange={(e, v) => setActiveTab(v)} variant="scrollable" scrollButtons="auto">
            {panels.map((tab, index) => (
              <Tab key={String(index + 1)} label={tab.label} value={String(index + 1)} />
            ))}
          </TabListFp>
          {panels.map((tab, index) => (
            <TabPanel key={String(index + 1)} value={String(index + 1)} className={classes.tabPanel} >
              {tab.value}
            </TabPanel>
          ))}
        </TabContext>
      )}
    </PageContainer>
  );
};

export default Cards;
